import React, { useEffect, useState, useMemo, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useOutletContext ,useLocation,Link,useNavigate} from "react-router-dom";
import GameSvcMnyDpstPrdtLstApi from "Apis/GameSvcMnyDpstPrdtLstApi";
import "Assets/css/Shop.css";
import ImgWithFallback from "Utils/ImgWithFallback";
import Pagination from "react-js-pagination";
import MgpStore from 'Stores/Store';
import CtntCategoryMenu from "Components/CtntCategoryMenu";
import GamePageBanner from "Components/GamePageBanner";
import MembGameSvcMnyApi from "Apis/MembGameSvcMnyApi";
import DpstOdrInfotApi from "Apis/DpstOdrInfotApi";
import EtcCtxtApi from "Apis/EtcCtxtApi";
import { useSelector } from "react-redux";
import ShopCtntMdlalUi from "Views/Shop/ShopCtntMdlalUi";
import MyCashSection from "Views/Shop/components/MyCashSection";
import ShopSlideUi, { ShopSlideItem } from "Views/Shop/ShopSlideUi";
import ShopBnrLstApi from "Apis/ShopBnrLstApi";
import { useGtm, fetchAdPayload, getKstTimestamp } from 'hooks/useGtm';
import ShopItemMdalUi from "./ShopItemMdlalUi";
import ApiResultModal from "Components/ApiResultModal";
import ShopDpstResultLayer from "Components/ShopDpstResultLayer";
interface CashState {
    loginYn: string;
    nickname: string;
    rcmnCd: string;
    gameMnyNm: string;
    loginId: string;
    membNo: number;
    totMny: number;
    paidMny: number;
    freeMny: number;
}

interface ShopModalProductState {
    gameSvcCd: string;
    shopKindCd: string;
    prdtCd: string;
    pymtCrncyType?: string;
    forceCtntModal?: boolean;
    rcmnPrdtCd?: string;
}

interface ShopBannerItem {
    gameSvcCd?: string;
    aplyStrtDtime?: string | number;
    aplyStopDtime?: string | number;
    bnrTitl?: string;
    bnrCtxt?: string;
    bnrDesc?: string;
    lnkUrlAddr?: string;
    lnkUrlTxt?: string;
    bnrFileUrl?: string;
    moBnrFileUrl?: string;
    lnkTrgtCd?: string;
}

const isPaymentSuccessCode = (code: string) => code === "PYMT0000" || code === "PYMT3502" || code === "COMM0000";

const createShopBannerDummyImage = (index: number) =>
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="1370" height="222" viewBox="0 0 1370 222"><rect width="1370" height="222" fill="#E6EAF0"/><rect x="1" y="1" width="1368" height="220" fill="none" stroke="#C7D0DB" stroke-width="2"/><text x="50%" y="44%" dominant-baseline="middle" text-anchor="middle" fill="#6D7A8A" font-family="Arial, sans-serif" font-size="34" font-weight="700">SHOP BANNER DUMMY ${index}</text><text x="50%" y="62%" dominant-baseline="middle" text-anchor="middle" fill="#8795A8" font-family="Arial, sans-serif" font-size="24" font-weight="600">1370 x 222</text></svg>`
    );

const ShopLstUi =({gameSvcCd,ctntKindCd,ctntCtgrCdName,LstType}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const navigate = useNavigate();
    
    // location must be available before parsing URLSearchParams
    const location = useLocation();

    // URL 파라미터 실시간 추출 (메뉴 변경 및 페이지 변경 감지용)
    const getCurrentParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            currentGameSvcCd: params.get("gameSvcCd") || gameSvcCd,
            currentCtntCtgrCd: params.get("ctntKindCd") || ctntKindCd,
            currentPage: parseInt(params.get("page") || "1")
        };
    };
    const { push: gtmPush } = useGtm();
    // 현재 URL 파라미터를 memoize — location.search 변경 시 재계산
    const currentParams = useMemo(() => getCurrentParams(), [location.search, gameSvcCd, ctntKindCd]);

    const query = new URLSearchParams(location.search);
    // initial gameSvcCd derived from query or prop
    let getGameSvcCd = query.get("gameSvcCd") || gameSvcCd;
    // use ctntKindCd query param (content kind) as the initial shop/category selector
    const [ShopKindCdState,setshopKindCdState] = useState(query.get("ctntKindCd") || ctntKindCd || query.get("shopKindCd"));
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [prdtLstState,setPrdtLstState] = useState([]);
    const [adPayload, setAdPayload] = useState<Record<string, unknown>>({});
    const [pageTitlState,setPageTitlState] = useState<string|null>(null);
    const [myCashState,setMyCashState] = useState<CashState | null>(null);
    const [showFreeBrickBtn, setShowFreeBrickBtn] = useState(true);
    const [isBrickTooltipOpen, setIsBrickTooltipOpen] = useState(false);
    const [isShopCtntModalOpen, setIsShopCtntModalOpen] = useState(false);
    const [selectedPrdtState, setSelectedPrdtState] = useState<ShopModalProductState | null>(null);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [resultModalAction, setResultModalAction] = useState<(() => void) | null>(null);
    const [shopBannerState, setShopBannerState] = useState<ShopBannerItem[]>([]);
    const lastDpstResultRef = useRef<{ key: string; receivedAt: number }>({ key: "", receivedAt: 0 });
    const closeLockTimerRef = useRef<number | null>(null);
    const [isModalCloseLocked, setIsModalCloseLocked] = useState(false);
    const [dpstResultOpenState, setDpstResultOpenState] = useState(false);
    const [dpstResultLoadingState, setDpstResultLoadingState] = useState(false);
    const [dpstResultDataState, setDpstResultDataState] = useState<any>(null);
    const [dpstOdrInfoState, setDpstOdrInfoState] = useState<any>(null);
    const [dpstTotMnyState, setDpstTotMnyState] = useState<string>("0");
    const [pymtGuideCtxtState, setPymtGuideCtxtState] = useState("");
    const [isItemResultModeState, setIsItemResultModeState] = useState(false);
    const storeLang = useSelector((state: any) => state.LangSetState?.Lang);
    const loginInfoState = useSelector((state: any) => state.LoginInfoState?.LoginInfo?.apiBody);
    const loginInfoRaw = useSelector((state: any) => state.LoginInfoState?.LoginInfo);
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const canShowFreeBrickBtn = idntMthdCd === "NA";
    const firstLetter = (loginInfoState?.loginId || myCashState?.loginId || myCashState?.nickname || '').charAt(0).toUpperCase();
    const shopSlideItems = useMemo<ShopSlideItem[]>(() => {
        const mappedSlides = shopBannerState
            .filter((banner: any) => !!banner?.bnrFileUrl || !!banner?.moBnrFileUrl || !!banner?.mobBnrFileUrl || !!banner?.mobileBnrFileUrl)
            .map((banner: any, idx) => {
                const detectedMobileBannerUrl = Object.entries(banner || {}).find(([key, value]) => {
                    if (typeof value !== "string" || !value.trim()) {
                        return false;
                    }
                    return /(mo|mob|mobile).*(bnr|banner).*(url|file)|(bnr|banner).*(mo|mob|mobile).*(url|file)/i.test(key);
                })?.[1] as string | undefined;

                return {
                    id: `${banner.gameSvcCd || "SHOP"}-${idx}`,
                    gameSvcCd: banner.gameSvcCd,
                    aplyStrtDtime: banner.aplyStrtDtime,
                    aplyStopDtime: banner.aplyStopDtime,
                    bnrTitl: banner.bnrTitl,
                    bnrCtxt: banner.bnrCtxt,
                    bnrDesc: banner.bnrDesc,
                    lnkUrlAddr: banner.lnkUrlAddr,
                    lnkUrlTxt: banner.lnkUrlTxt,
                    bnrFileUrl: banner.bnrFileUrl || "",
                    moBnrFileUrl: banner.moBnrFileUrl || banner.mobBnrFileUrl || banner.mobileBnrFileUrl || detectedMobileBannerUrl || "",
                    lnkTrgtCd: banner.lnkTrgtCd,
                };
            });

        if (mappedSlides.length > 0) {
            return mappedSlides;
        }

        return Array.from({ length: 4 }, (_, idx) => ({
            id: `shop-banner-dummy-${idx + 1}`,
            bnrFileUrl: createShopBannerDummyImage(idx + 1),
            bnrTitl: `shop-banner-dummy-${idx + 1}-1370x222`,
        }));
    }, [shopBannerState]);
        // 현재 URL에서 대메뉴 찾기 (메뉴 데이터용)
    const currentMainMenu = gameMainPageData?.menu?.find((menu: any) => {
        if (currentParams.currentCtntCtgrCd) {
            return menu.subMenuLst?.some((sub: any) => {
                const urlParams = new URLSearchParams(sub.url?.split('?')[1] || '');
                const subCtntKindCd = urlParams.get('ctntKindCd');
                return subCtntKindCd === currentParams.currentCtntCtgrCd;
            });
        }
        const currentPath = location.pathname.toLowerCase();
        const menuCd = menu.menuCd?.toLowerCase() || '';
        return currentPath.includes(menuCd) || 
               menu.subMenuLst?.some((sub: any) => {
                   const subMenuCd = sub.menuCd?.toLowerCase() || '';
                   return currentPath.includes(subMenuCd);
               });
    });

    const LstChngFunc = (ShopKindCdState:string) => {
        // update local state only; list fetch is centralized in effect below
        setshopKindCdState(ShopKindCdState);
        setPageState(1);
        switch(ShopKindCdState){
            case "MNY":
                setPageTitlState(langData&&langData.GAME_SHOP_CTGR_DPST_LBL_00);
                break;
            case "SUBS":
                setPageTitlState(langData&&langData.GAME_SHOP_CTGR_ITEM_LBL_00);
            break;
            case "PRSN":
                setPageTitlState(langData&&langData.GAME_SHOP_CTGR_PRSN_LBL_00);
            break;
        }
    }

    const refreshPrdtListState = () => {
        if (!ShopKindCdState) {
            setPrdtLstState([]);
            return Promise.resolve();
        }

        return GameSvcMnyDpstPrdtLstApi(getGameSvcCd, ShopKindCdState, pageState, "")
            .then((resp) => {
                setPrdtLstState(resp.apiBody.prdtLst);
                setOnePageSizeState(resp.apiBody.onePageSize);
                setTotPstdCntState(resp.apiBody.totCnt);
            })
            .catch(() => {
                setPrdtLstState([]);
            });
    };
    
    useEffect(()=>{
        refreshMyCashState();
        refreshPrdtListState();
        switch(ShopKindCdState){
            case "MNY":
                setPageTitlState(langData&&langData.GAME_SHOP_CTGR_DPST_LBL_00);
            break;
            case "SUBS":
                setPageTitlState(langData&&langData.GAME_SHOP_CTGR_ITEM_LBL_00);
            break;
            case "PRSN":
                setPageTitlState(langData&&langData.GAME_SHOP_CTGR_PRSN_LBL_00);
            break;
        }
    },[ShopKindCdState, pageState, getGameSvcCd, storeLang, langData])

    useEffect(() => {
        ShopBnrLstApi(getGameSvcCd)
            .then((resp) => {
                const banners = Array.isArray(resp?.apiBody?.bnrLst) ? resp.apiBody.bnrLst : [];
                setShopBannerState(banners);
            })
            .catch(() => {
                setShopBannerState([]);
            });
        fetchAdPayload(getGameSvcCd)
            .then((payload) => {
                setAdPayload(payload);
            })
            .catch(() => {
                setAdPayload({});
            });
    }, [getGameSvcCd, storeLang]);

    useEffect(() => {
        const etcGameSvcCd = String(getGameSvcCd || "BBO").toUpperCase();
        EtcCtxtApi("CTNT_KIND_ETC", "PYMT_GUIDE", etcGameSvcCd)
            .then((resp) => {
                if (resp.apiHdr.code === "COMM0000") {
                    setPymtGuideCtxtState(resp.apiBody.ctxt || "");
                }
            })
            .catch(() => {
                setPymtGuideCtxtState("");
            });
    }, [getGameSvcCd, storeLang]);

    // Re-fetch when URL params change (e.g., referrer or query modifications)
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const newGameSvcCd = params.get('gameSvcCd') || gameSvcCd;
        const newKind = params.get('ctntKindCd') || params.get('shopKindCd') || ctntKindCd;
        const newPage = parseInt(params.get('page') || '1');

        // Update local state if changed
        if (newKind && newKind !== ShopKindCdState) {
            setshopKindCdState(newKind);
        }
        if (newPage && newPage !== pageState) {
            setPageState(newPage);
        }

    }, [location.search, gameSvcCd, ctntKindCd]);
    const handlePageChange = (pageState:any) => {
        setPageState(pageState);
      };
    const refreshMyCashState = () => {
        return MembGameSvcMnyApi("BBO")
            .then((resp) => {
                setMyCashState(resp.apiBody);
            })
            .catch(() => {
                // ignore refresh errors
            });
    };
          // 동적 메뉴 데이터 - 현재 대메뉴의 subMenuLst 추출
          const ctntMenuData = currentMainMenu?.subMenuLst?.map((subMenu: any) => {
              // URL에서 ctntKindCd 파라미터 추출
              const urlParams = new URLSearchParams(subMenu.url?.split('?')[1] || '');
              const ctntKindCd = urlParams.get('ctntKindCd') || subMenu.menuCd;
              
              return {
                  Link: subMenu.url || '#',
                  Txt: subMenu.menuNm,
                  Display: subMenu.useYn,
                  Code: ctntKindCd, // URL에서 추출한 ctntKindCd 사용
                  BlankYn: subMenu.blankYn
              };
          }) || [];
      const visibleMenus = ctntMenuData.filter((menu: any) => menu.Display === "Y");

    useEffect(() => {
        const handleOutsideClose = (event: MouseEvent | TouchEvent) => {
            const target = event.target as HTMLElement;
            if (!target.closest(".brickInfoTooltipWrap")) {
                setIsBrickTooltipOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClose);
        document.addEventListener("touchstart", handleOutsideClose, { passive: true });

        return () => {
            document.removeEventListener("mousedown", handleOutsideClose);
            document.removeEventListener("touchstart", handleOutsideClose);
        };
    }, []);

    const handleBrickInfoToggle = () => {
        if (typeof window !== "undefined" && window.matchMedia("(hover: none), (pointer: coarse)").matches) {
            setIsBrickTooltipOpen((prev) => !prev);
        }
    };

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setResultModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = resultModalAction;
        setResultModalAction(null);
        if (action) action();
    };

    const lockModalCloseTemporarily = () => {
        setIsModalCloseLocked(true);
        if (closeLockTimerRef.current) {
            window.clearTimeout(closeLockTimerRef.current);
        }
        closeLockTimerRef.current = window.setTimeout(() => {
            setIsModalCloseLocked(false);
            closeLockTimerRef.current = null;
        }, 3000);
    };

    const openShopCtntModal = (item: any) => {
        const normalizedKindCd = String(item?.prdtKindCd || item?.shopKindCd || "").trim().toUpperCase();
        const isItemKind = normalizedKindCd === "ITEM_MNY";
        const pymtCrncyType = item.pymtCrncyType || item.pchsCrncyType || (isItemKind ? "MNY" : "");
        const itemGameSvcCd = item.gameSvcCd || getGameSvcCd;
        const itemShopKindCd = item.prdtKindCd || item.shopKindCd || ShopKindCdState;
        const itemPrdtCd = item.prdtCd;

        const isLoginResolved = loginInfoRaw !== null;
        const isLoggedIn = Boolean(loginInfoState && loginInfoState.login);

        if (isLoginResolved && !isLoggedIn) {
            const currentUrl = encodeURIComponent(location.pathname + location.search);
            openResultModal(
                (langData && langData.COMM_ALERT_LOGIN_REQUIRED_00) || "로그인이 필요한 서비스입니다.",
                () => navigate(`/Login?referrer=${currentUrl}`)
            );
            return;
        }

        setSelectedPrdtState({
            gameSvcCd: itemGameSvcCd,
            shopKindCd: itemShopKindCd,
            prdtCd: itemPrdtCd,
            pymtCrncyType,
            forceCtntModal: false,
            rcmnPrdtCd: "",
        });
        setIsShopCtntModalOpen(true);
    };

    const openChargeProductModal = (targetPrdtCd: string, sourcePrdtCd: string) => {
        const fallbackGameSvcCd = selectedPrdtState?.gameSvcCd || getGameSvcCd;

        console.log("[ShopLstUi] openChargeProductModal", {
            targetPrdtCd,
            sourcePrdtCd,
        });

        setSelectedPrdtState({
            gameSvcCd: fallbackGameSvcCd,
            shopKindCd: "MNY",
            prdtCd: String(targetPrdtCd),
            pymtCrncyType: "REAL",
            forceCtntModal: true,
            rcmnPrdtCd: String(sourcePrdtCd || ""),
        });
        setIsShopCtntModalOpen(true);
    };

    const switchToItemProductModal = (targetPrdtCd: string, sourcePrdtCd: string) => {
        const normalizedTargetPrdtCd = String(targetPrdtCd || "").trim();
        console.log("[ShopLstUi] switchToItemProductModal called", {
            targetPrdtCd,
            normalizedTargetPrdtCd,
            sourcePrdtCd,
        });

        if (!normalizedTargetPrdtCd) {
            console.log("[ShopLstUi] switchToItemProductModal skipped: empty product code");
            return;
        }

        const matchedItem = (prdtLstState as any[]).find(
            (item: any) => String(item.prdtCd) === normalizedTargetPrdtCd
        );

        setSelectedPrdtState({
            gameSvcCd: selectedPrdtState?.gameSvcCd || getGameSvcCd,
            shopKindCd: matchedItem?.prdtKindCd || selectedPrdtState?.shopKindCd || ShopKindCdState || "",
            prdtCd: normalizedTargetPrdtCd,
            pymtCrncyType: "MNY",
            forceCtntModal: false,
            rcmnPrdtCd: "",
        });
        setIsShopCtntModalOpen(true);
    };

    const openShopCtntModalFromBanner = (slide: ShopSlideItem) => {
        const href = slide.lnkUrlAddr;
        if (!href) {
            return;
        }

        let parsed: URL;
        try {
            parsed = new URL(href, window.location.origin);
        } catch {
            return;
        }

        const gameSvcCdParam = parsed.searchParams.get("gameSvcCd") || slide.gameSvcCd || getGameSvcCd;
        const prdtKindCdParam =
            parsed.searchParams.get("prdtKindCd") ||
            parsed.searchParams.get("shopKindCd") ||
            parsed.searchParams.get("ctntKindCd");
        const normalizedKindCd = String(prdtKindCdParam || "").trim().toUpperCase();
        const isItemKind = normalizedKindCd === "ITEM_MNY";
        const pymtCrncyTypeParam =
            parsed.searchParams.get("pymtCrncyType") ||
            parsed.searchParams.get("pchsCrncyType") ||
            (isItemKind ? "MNY" : "");
        const prdtCdParam = parsed.searchParams.get("prdtCd") || parsed.searchParams.get("ctntSno");

        if (!gameSvcCdParam || !prdtKindCdParam || !prdtCdParam) {
            return;
        }

        openShopCtntModal({
            gameSvcCd: gameSvcCdParam,
            prdtKindCd: prdtKindCdParam,
            prdtCd: prdtCdParam,
            pymtCrncyType: pymtCrncyTypeParam,
        });
    };

    const closeShopCtntModal = () => {
        if (isModalCloseLocked) {
            return;
        }
        setIsItemResultModeState(false);
        setIsShopCtntModalOpen(false);
        setSelectedPrdtState(null);
    };

    const closeDpstResultLayer = () => {
        setDpstResultOpenState(false);
        setDpstResultLoadingState(false);
        setDpstResultDataState(null);
        setDpstOdrInfoState(null);
        setIsModalCloseLocked(false);
        try {
            window.sessionStorage.removeItem("shopDpstReturnContext");
        } catch {
            // ignore session storage remove errors
        }
        refreshMyCashState();
        refreshPrdtListState();
    };

    const applyDpstResultPayload = (rawData: any) => {
        const data: any = rawData || {};
        const rcmnPrdtCd = String(data.rcmnPrdtCd || "").trim();
        const dpstCode = String(data.dpstCode || "").trim();
        if (!dpstCode && !rcmnPrdtCd) {
            return;
        }

        const dpstOdrNo = String(data.dpstOdrNo || "").trim();
        const dpstMsg = String(data.dpstMsg || "").trim();
        const pymtMthdNm = String(data.pymtMthdNm || "").trim();
        const prdtNm = String(data.prdtNm || "").trim();
        const paidMny = String(data.paidMny || "").trim();
        const freeMny = String(data.freeMny || "").trim();
        const odrAmt = String(data.odrAmt || "").trim();
        const pchsKindCd = String(
            data.pchsKindCd || data.prdtKindCd || selectedPrdtState?.shopKindCd || ShopKindCdState || "DPST"
        ).trim().toUpperCase();
        const resultKey = dpstOdrNo || `${dpstCode}|${dpstMsg}|${rcmnPrdtCd}|${pymtMthdNm}`;
        const now = Date.now();
        const { key: lastKey, receivedAt: lastReceivedAt } = lastDpstResultRef.current;

        if (resultKey && lastKey === resultKey && now - lastReceivedAt < 3000) {
            return;
        }
        lastDpstResultRef.current = {
            key: resultKey,
            receivedAt: now,
        };

        if (isPaymentSuccessCode(dpstCode) && !rcmnPrdtCd) {
            const tsKst = getKstTimestamp();
            gtmPush("Shop_Content_Purchase_Complete", {
                ts: tsKst,
                prdtCd: String(data.prdtCd || selectedPrdtState?.prdtCd || ""),
                pymtMthdCd: String(data.pymtMthdCd || ""),
                pymtMthdNm,
                prdtPrc: String(data.prdtPrc || ""),
                prdtCnt: Number(data.prdtCnt || 0),
                odrAmt,
                ...adPayload,
            });
        }

        if (rcmnPrdtCd) {
            switchToItemProductModal(rcmnPrdtCd, "");
            return;
        }

        const targetGameSvcCd = String(data.gameSvcCd || getGameSvcCd || "BBO");

        setDpstResultOpenState(true);
        setDpstResultLoadingState(true);
        setDpstResultDataState({
            dpstOdrNo,
            dpstCode,
            dpstMsg,
            gameSvcCd: targetGameSvcCd,
            closeYn: data.closeYn,
            rcmnPrdtCd,
            pymtMthdNm,
            prdtNm,
            paidMny,
            freeMny,
            odrAmt,
            pchsKindCd,
        });
        setDpstOdrInfoState(null);

        if (isShopCtntModalOpen) {
            setIsShopCtntModalOpen(false);
        }

        if (!dpstOdrNo) {
            setDpstResultLoadingState(false);
            return;
        }

        Promise.allSettled([
            DpstOdrInfotApi(targetGameSvcCd, dpstOdrNo, String(storeLang || "ko")),
            MembGameSvcMnyApi(targetGameSvcCd),
        ]).then((results) => {
            const [orderInfoResult, mnyResult] = results;
            if (orderInfoResult.status === "fulfilled") {
                setDpstOdrInfoState(orderInfoResult.value?.apiBody || null);
            }
            if (mnyResult.status === "fulfilled") {
                setDpstTotMnyState(String(mnyResult.value?.apiBody?.totMny ?? "0"));
            }
        }).finally(() => {
            setDpstResultLoadingState(false);
        });
    };
    const selectedPrdtFromList = (prdtLstState as any[]).find(
        (item: any) => String(item.prdtCd) === String(selectedPrdtState?.prdtCd || "")
    );
    const resolvedPymtCrncyType =
        selectedPrdtState?.pymtCrncyType ||
        selectedPrdtFromList?.pymtCrncyType ||
        selectedPrdtFromList?.pchsCrncyType ||
        "";
    const normalizedSelectedKindCd = String(selectedPrdtState?.shopKindCd || "").trim().toUpperCase();
    const isItemMnyKindSelected = normalizedSelectedKindCd === "ITEM_MNY";
    const isItemMnyModal =
        !selectedPrdtState?.forceCtntModal &&
        (resolvedPymtCrncyType === "MNY" || isItemMnyKindSelected);
    const onRequestClose = (getPrdtCd: string,pymtMthdCd: string, prdtPrc: string, prdtCnt: number, odrAmt: string) => {
            closeShopCtntModal();
            refreshMyCashState();
            refreshPrdtListState();
    }

    const onItemPurchaseSuccess = () => {
        refreshMyCashState();
        refreshPrdtListState();
    };
    useEffect(() => {
        if (!isShopCtntModalOpen) {
            return;
        }

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = prevOverflow;
        };
    }, [isShopCtntModalOpen]);

    useEffect(() => {
        return () => {
            if (closeLockTimerRef.current) {
                window.clearTimeout(closeLockTimerRef.current);
                closeLockTimerRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        const handleDpstMessage = (event: MessageEvent) => {
            const data: any = event?.data;
            if (!data || typeof data !== "object") {
                return;
            }

            if (data.type !== "navigateToResult" && data.type !== "dpstResult") {
                return;
            }
            applyDpstResultPayload(data);
        };

        window.addEventListener("message", handleDpstMessage);

        return () => {
            window.removeEventListener("message", handleDpstMessage);
        };
    }, [isShopCtntModalOpen, navigate, getGameSvcCd, prdtLstState, selectedPrdtState, ShopKindCdState, langData, storeLang]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("dpstFromPg") !== "Y") {
            return;
        }

        applyDpstResultPayload({
            gameSvcCd: params.get("gameSvcCd"),
            dpstOdrNo: params.get("dpstOdrNo"),
            dpstCode: params.get("dpstCode"),
            dpstMsg: params.get("dpstMsg"),
            closeYn: params.get("closeYn"),
            rcmnPrdtCd: params.get("rcmnPrdtCd"),
            pymtMthdNm: params.get("pymtMthdNm"),
            prdtNm: params.get("prdtNm"),
            paidMny: params.get("paidMny"),
            freeMny: params.get("freeMny"),
            odrAmt: params.get("odrAmt"),
            pchsKindCd: params.get("pchsKindCd"),
        });

        [
            "dpstFromPg",
            "dpstOdrNo",
            "dpstCode",
            "dpstMsg",
            "closeYn",
            "rcmnPrdtCd",
            "pymtMthdNm",
            "prdtNm",
            "paidMny",
            "freeMny",
            "odrAmt",
            "pchsKindCd",
        ].forEach((key) => params.delete(key));

        navigate({ pathname: location.pathname, search: params.toString() ? `?${params.toString()}` : "" }, { replace: true });
    }, [location.pathname, location.search, navigate]);

    return(
        <>
        <Helmet>
            <title>{process.env.REACT_APP_TITLE_PREFIX} Shop</title>
        </Helmet>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <div className="BgW pt140 shopLstBg">
            <ShopSlideUi
                className="container eventSlideWrap"
                slides={shopSlideItems}
                autoplayDelay={10000}
                gameSvcCd={getGameSvcCd}
                onLayerPopup={openShopCtntModalFromBanner}
                langData={langData}
            />
            <div className="shopContainer">
                <div className="ctntCtgrTitlTxt">
                    <CtntCategoryMenu
                        menus={visibleMenus}
                        activeCode={currentParams.currentCtntCtgrCd || ''}
                        onPageChange={handlePageChange}
                        onSelect={LstChngFunc}
                    />
                    <a href={"/GamePage/GamePrbb?gameSvcCd=bbo"} target="_blank">
                        <p>{langData&&langData.GLB_PRBB_LINK_BTN}</p>
                        <img src={process.env.PUBLIC_URL + "/images/blankIcon.png"} alt="" />
                    </a>
                </div>
                <MyCashSection
                    myCashState={myCashState}
                    loginInfoState={loginInfoState}
                    firstLetter={firstLetter}
                    isBrickTooltipOpen={isBrickTooltipOpen}
                    onToggleBrickInfo={handleBrickInfoToggle}
                    langData={langData}
                    gameSvcCd={getGameSvcCd}
                    shopKindCd={ShopKindCdState || ""}
                />
                <div className="itemLstWrap">
                    <ul>
                        {prdtLstState&&prdtLstState.length == 0 && (
                            <div className="noDataWrap">{langData&&langData.GAME_SHOP_NO_PRDT_LBL_00}</div>
                        )}
                        
                        {prdtLstState&&prdtLstState.map((key:any)=>(
                            <li className="shopLstItem" key={key.prdtCd}>
                                {key.soutYn === "Y" ?
                                    <div className="shopLstItemCtxt disabled">
                                        <div className="shopItemImg">
                                            <div className="shopItemImgInner">
                                                <ImgWithFallback src={key.imgUrl} alt="" />
                                                <img src={process.env.PUBLIC_URL + "/images/Shop/slodout.png"} alt="" className="soldOutImg" />
                                            </div>
                                        </div>
                                        <div className="shopLstItemTxtWrap">
                                            <h1>{key.prdtNm}</h1>
                                            <h2>{(key.linePrdtDesc && String(key.linePrdtDesc).trim()) || "\u00A0"}</h2>
                                            <div className="shopLstItemBtnWrap ">
                                                <div className="buttonBgB disabled">
                                                    <p>{langData&&langData.PRDT_SOLD_OUT_BTN_00}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div
                                        className="shopLstItemCtxt"
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => openShopCtntModal(key)}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter" || event.key === " ") {
                                                event.preventDefault();
                                                openShopCtntModal(key);
                                            }
                                        }}
                                    >
                                        <div className="shopItemImg">
                                            <ImgWithFallback src={key.imgUrl} alt="" />
                                        </div>
                                        <div className="shopLstItemTxtWrap">
                                            <h1>{key.prdtNm}</h1>
                                            <h2>{(key.linePrdtDesc && String(key.linePrdtDesc).trim()) || "\u00A0"}</h2>
                                            <div className="shopLstItemBtnWrap">
                                                <div className="buttonBgB">
                                                    <p><span className="pchsCrncySign">{key.pchsCrncySign}</span>{(Number(key.prdtUntPrc) || 0).toLocaleString()}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </li>

                        ))}
                    </ul>
                </div>
                <div className="ctntPageWrap">
                    <Pagination
                        activePage={pageState}
                        itemsCountPerPage={onePageSizeState}
                        totalItemsCount={totPstdCntState}
                        pageRangeDisplayed={5}
                        firstPageText={""}
                        linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                        prevPageText={""}
                        linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                        nextPageText={""}
                        linkClassNext={"pagenationBtn pagenationNextBtn"}
                        lastPageText={""}
                        linkClassLast={"pagenationBtn pagenationLastBtn"}
                        onChange={handlePageChange}
                    />
                </div>
            </div>
            {showFreeBrickBtn && canShowFreeBrickBtn && (
                <div className="freeBrickBtn">
                    <button className="freeBrickCloseBtn" onClick={() => setShowFreeBrickBtn(false)}>
                        <img src={process.env.PUBLIC_URL + "/images/Shop/freeBrickCloseBtn.png"} alt={langData?.COMM_MAIN_CLOSE_BTN_00 || "닫기"} />
                    </button>
                    <Link to={`/MyPage/eml`} className="freeBrickLink">
                        <img src={process.env.PUBLIC_URL + "/images/freebrickBtn.png"} alt="" className="brickImg"/>
                    </Link>
                </div>
            )}
            {isShopCtntModalOpen && selectedPrdtState && (
                <div className="shopCtntModalBackdrop" onClick={closeShopCtntModal}>
                    <div className={`shopCtntModalContainer ${isItemMnyModal ? "shopCtntModalContainerNarrow " : ""}${isItemResultModeState ? "shopCtntModalContainerResult " : ""}`.trim()} onClick={(event) => event.stopPropagation()}>
                        <button
                            type="button"
                            className="shopCtntModalCloseBtn"
                            onClick={closeShopCtntModal}
                            aria-label={langData?.COMM_MAIN_CLOSE_BTN_00 || "닫기"}
                        >
                            ×
                        </button>
                        {isItemMnyModal ? (
                            <ShopItemMdalUi
                                gameSvcCd={selectedPrdtState.gameSvcCd}
                                shopKindCd={selectedPrdtState.shopKindCd}
                                prdtCd={selectedPrdtState.prdtCd}
                                usePreviewDesign={true}
                                onRequestClose={onRequestClose}
                                onNeedChargeProduct={openChargeProductModal}
                                onPurchaseSuccess={onItemPurchaseSuccess}
                                useParentDpstResultHandler={true}
                                onResultModalModeChange={setIsItemResultModeState}
                            />
                        ) : (
                            <ShopCtntMdlalUi
                                gameSvcCd={selectedPrdtState.gameSvcCd}
                                shopKindCd={selectedPrdtState.shopKindCd}
                                prdtCd={selectedPrdtState.prdtCd}
                                rcmnPrdtCd={selectedPrdtState.rcmnPrdtCd}
                                pymtCrncyType={resolvedPymtCrncyType}
                                forceCtntModal={Boolean(selectedPrdtState.forceCtntModal)}
                                prdtLstState = {prdtLstState}
                                onRequestClose={onRequestClose}
                                onRequestSwitchToItemModal={switchToItemProductModal}
                                onBeforeSubmit={lockModalCloseTemporarily}
                                useParentDpstResultHandler={true}
                            />
                        )}
                    </div>
                </div>
            )}
            {dpstResultOpenState && (
                <div className="shopCtntModalBackdrop" onClick={closeDpstResultLayer}>
                    <div className="shopCtntModalContainer shopCtntModalContainerNarrow shopCtntModalContainerResult" onClick={(event) => event.stopPropagation()}>
                        <button
                            type="button"
                            className="shopCtntModalCloseBtn"
                            onClick={closeDpstResultLayer}
                            aria-label={langData?.COMM_MAIN_CLOSE_BTN_00 || "닫기"}
                        >
                            ×
                        </button>
                        <ShopDpstResultLayer
                            loading={dpstResultLoadingState}
                            resultData={dpstResultDataState}
                            orderInfo={dpstOdrInfoState}
                            langData={langData}
                            pymtGuideCtxt={pymtGuideCtxtState}
                            totMny={dpstTotMnyState}
                            myCashTotMny={myCashState?.totMny}
                            fallbackPrdtNm={dpstResultDataState?.prdtNm}
                            onRequestClose={closeDpstResultLayer}
                            onClose={closeDpstResultLayer}
                        />
                    </div>
                </div>
            )}
        </div>
        </>
    )
}



export default ShopLstUi;